var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h1',{staticClass:"display-1"},[_vm._v("404")]),_c('h2',{staticClass:"display-2"},[_vm._v("Página no encontrada")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }